/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PayItemsWithPointsDto } from '../../models/pay-items-with-points-dto';
import { TabDetailDto } from '../../models/tab-detail-dto';

export interface PosTabsControllerPayItemsWithPoints$Params {
  id: string;
      body: PayItemsWithPointsDto
}

export function posTabsControllerPayItemsWithPoints(http: HttpClient, rootUrl: string, params: PosTabsControllerPayItemsWithPoints$Params, context?: HttpContext): Observable<StrictHttpResponse<TabDetailDto>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerPayItemsWithPoints.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TabDetailDto>;
    })
  );
}

posTabsControllerPayItemsWithPoints.PATH = '/pos/tabs/{id}/pay-items-with-points';
